import { productInfo } from "@/mocks/product";

const heroBg = "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/69061bee964202fe94444be6ae4512ef.png";

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center text-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="Purrfect Pinot Noir lifestyle"
          className="w-full h-full object-cover object-center"
        />
        {/* Multi-layer gradient for readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center px-6 py-32 md:py-40 max-w-4xl mx-auto">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 text-white/90 text-xs font-medium tracking-wider backdrop-blur-sm border border-white/20 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
          Exclusively at Costco
        </span>

        <p className="text-sm md:text-base text-white/70 font-medium tracking-[0.25em] uppercase mb-4">
          {productInfo.subtitle}
        </p>

        <h1
          className="text-4xl md:text-6xl lg:text-7xl font-semibold text-white leading-tight tracking-tight drop-shadow-lg"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {productInfo.name}
        </h1>

        <p className="mt-4 text-lg md:text-xl text-white/80 font-light tracking-wide drop-shadow-md max-w-2xl">
          {productInfo.tagline}
        </p>

        <p className="mt-3 text-sm md:text-base text-white/60 max-w-lg drop-shadow">
          Natural jute rope. Sturdy wood base. Effortless 3-step assembly. A scratching post that looks like fine wine.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="#product"
            className="px-8 py-3.5 bg-white text-stone-900 text-sm font-semibold rounded-full hover:bg-stone-100 transition-colors whitespace-nowrap shadow-lg"
          >
            Explore Product
          </a>
          <a
            href="#find-at-costco"
            className="px-8 py-3.5 border border-white/40 text-white text-sm font-medium rounded-full hover:bg-white/15 transition-colors whitespace-nowrap backdrop-blur-sm"
          >
            Find at Costco
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-5 h-8 rounded-full border-2 border-white/30 flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/60 rounded-full" />
        </div>
      </div>
    </section>
  );
}